export default __webpack_public_path__ + "static/media/Coffee-Class.925c645c.jpg";